(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9553],{

/***/ 31017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./src/constants/index.ts + 6 modules
var constants = __webpack_require__(22120);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/poshfest-2022/index.tsx









function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-08-31",
      tag: "Poshmark",
      title: "PoshFest 2022: Everything You Need to Know",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Poshmark has always been known for its strong community of users (aka Poshers). The platform is also big on cultivating the social aspect of reselling, may it be through activities such as sharing others' closets or events - the biggest of which is the annual PoshFest conference."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Like its previous editions, ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://www.poshfest.poshmark.com/",
          children: "PoshFest 2022"
        }), " is going to be two full days of learning, networking, and having lots of fun with your old and new found PFFs. This in-person event will happen on September 29 and 30, 2022, at the Royal Sonesta in Houston, Texas."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The conference provides a mix of general and specialized topics, as well as a blend of activities that involve either big or small groups."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Who can join PoshFest 2022?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Poshmark welcomes everyone to the event. Whether you're a newbie or already a seasoned Posher, you can come in. However, you need to be at least 13 years old to participate and at least 21 to be admitted to the evening parties."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Tickets are available for purchase ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tickets.poshmark.com/event/poshfest-2022",
          children: "online"
        }), ". So even if you're not based in the US, you can still attend as long as you purchase a ticket.. The ticket costs $279 and provides access to all of the breakout sessions and workshops, plus the Posh Party on Day 2."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Each ticket also comes with a goodie bag and complimentary breakfast and lunch."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "The Pros and Cons of attending this Posh event"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Now that you know the basic information, it's time to drill down to the details that could help you decide whether to purchase a PoshFest 2022 ticket or not."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "First, let's consider the upsides:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "There's a wealth of insights and insider tips in store for you."
            }), " any successful entrepreneur would tell you, learning should never stop. You should invest in upgrading your tools of the trade that help fuel your productivity, so why not invest in your knowledge? You are the brains behind your reselling business, after all."]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Based on the impressive line-up of PoshFest 2022, you can expect to learn from different formats. There will be a panel talk, smaller roundtables that are more intimate, and one-on-one consultations."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "The afternoon breakout sessions and workshops cover a wide range of interesting and exciting topics for resellers, depending on where you are in your Poshmark journey."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "There's a session tackling the building blocks of a thriving Poshmark business. Another is about harnessing the power of data and insights. For those planning to up their content creation game, there's a workshop about producing social media clips and how to leverage them to promote your business."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "There are plenty of opportunities to network."
            }), " you're building your Posh circle from scratch or simply widening it, PoshFest 2022 is the right place for you. Aside from the sessions solely dedicated to networking, you can easily meet new contacts throughout the event as it is designed to be conducive to socializing. Not to mention the fun and festive evening parties you wouldn't want to miss!"]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "Experience the Poshmark culture in a couple of days."
            }), " If you're new to Poshmark and would like to be a successful seller (and even a Posh Ambassador), PoshFest 2022 is the fastest way to immerse in and embrace the platform's unique, vibrant culture."]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "Hear updates straight from the Poshmark think tanks themselves."
            }), " CEO and founder Manish Chandra will reveal some exciting news for Poshers, while the product and development team will unveil new tools and features during the highly anticipated Hackathon session."]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "Witness a fun new segment."
            }), " What's also notable about this year's Posh Fest is the addition of the Secondhand Style Fashion Show during the Posh Party. Here, Poshers will strut down the runway wearing clothes from their closets!"]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Now, we move on to the downsides of attending Poshfest 2022:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "The relatively steep ticket price."
          }), " While some could painlessly cough up almost 300 dollars for a two-day event, others may think twice about it. Note that paying half of the amount is not possible if you intend to participate in either Day 1 or Day 2 only."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "There are other expenses to account for."
          }), " Even if you can afford the ticket price, you need to take into consideration other incidental expenses that do add up. Depending on how far you are from the venue, you might have to shell out money for accommodations, airfare, and food beyond the complimentary meals."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "The talks and workshops may not offer anything new to you."
          }), " If you're the type who likes to attend conferences and take online courses, there's a chance you already know most of what will be discussed at PoshFest 2022. If you've attended a Posh Fest in the past, you might also get bored listening to certain areas of the event, such as hearing about successful Poshers' reselling journey."]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The list above serves as a guide only. Of course, the decision would depend entirely on you and factors such as your resources, as well as your goals and priorities as a seller."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "The daily Posher habits that matter"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "PoshFest is a great annual event to participate in, especially if you are planning to widen your network and boost your presence on the platform. But just as important as this big-ticket event are the daily habits you have in place as a Poshmark seller."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As a social marketplace, Poshmark emphasizes actions that encourage building connections. Hence, the number of followers you have and how often you share your listings and other Poshers' closets matter, for instance."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The key to acing these important but time - and effort - draining tasks is to automate them. OneShop's automation capabilities are best in class and have proven to help thousands of resellers for years now. Once you've tried it, you won't be able to imagine going the manual route again!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Aside from automation, OneShop provides convenience to a reseller's day-to-day workflow. If you're a reseller on multiple marketplaces, OneShop has the smart system to streamline the way you draft your listings, cross-list, re-list, manage your orders, and more."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Make OneShop part of your business today and see how it can be instrumental in growing your reselling venture.", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "Sign-up now"
        }), ", set up your account in less than three minutes, and enjoy a ", /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: constants/* Marketing.TrialDuration */.F1.TrialDuration
        }), "-day free trial!"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/poshfest-2022.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "PoshFest 2022: Everything You Need to Know"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Touted as the ultimate Poshmark experience, PoshFest is happening again soon. How to join PoshFest 2022? Read up and decide if it\u2019s worth a go or not."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/poshfest-2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/poshfest-2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "PoshFest 2022: Everything You Need to Know"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Touted as the ultimate Poshmark experience, PoshFest is happening again soon. How to join PoshFest 2022? Read up and decide if it\u2019s worth a go or not."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=3"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-08-31T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-08-31T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 19285:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/poshfest-2022",
      function () {
        return __webpack_require__(31017);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(19285); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);